import {
  GeojsonProj,
  Projections,
} from '@one-click-lca/3d-buildings-shared/features';
import {LatLngBounds} from 'leaflet';

import {GEOSERVER_GEOMETRY_TYPES, TLegendCategory} from './legendTypes';

export const getBounds = (bounds: LatLngBounds): number[] => {
  const {lat: latSW, lng: lngSW} = bounds.getSouthWest();
  const {lat: latNE, lng: lngNE} = bounds.getNorthEast();
  const SW = GeojsonProj.reprojectCoordFromLatLng(
    latSW,
    lngSW,
    Projections.EPSG_2154,
  );
  const NE = GeojsonProj.reprojectCoordFromLatLng(
    latNE,
    lngNE,
    Projections.EPSG_2154,
  );

  return [...SW, ...NE];
};

export const getCqlFilter = (
  prescriptionJoinedTypes: string[],
  bounds: number[],
): string => {
  const BBOX = `BBOX(geom,${bounds.join(',')})`;
  const types = prescriptionJoinedTypes
    .flatMap(t => t.split(','))
    .reduce((typesString, t) => (typesString += `type='${t}' or `), '')
    .slice(0, -4);

  return `${BBOX} and (${types})`;
};

export const getCheckedTypes = (
  legendCategories: TLegendCategory[],
): string[] =>
  legendCategories.flatMap(category =>
    category.elements
      .filter(el => el.isCheckedByDefault)
      .map(({types}) => types),
  );

export const getPrescriptionTypes = (
  convertedPrescriptionTypes: string,
): string => convertedPrescriptionTypes.split('_')[0];
const getGeometryType = (convertedPrescriptionTypes: string) =>
  convertedPrescriptionTypes.split('_')[1];

export const convertPrescriptionTypes = (
  prescriptionTypes: string[],
  geometryType: GEOSERVER_GEOMETRY_TYPES,
): string[] =>
  prescriptionTypes
    .filter(types => getGeometryType(types) === geometryType)
    .map(types => getPrescriptionTypes(types));
